/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../../core";
import { SpaceConfigId } from "../../../../commons/types/SpaceConfigId";
import { SpacePatternConfig } from "./SpacePatternConfig";
export const SpacePattern = core.serialization
    .object({
    id: SpaceConfigId,
})
    .extend(SpacePatternConfig);
